import { render, staticRenderFns } from "./WineRangeAccessibility.vue?vue&type=template&id=35467876&scoped=true"
import script from "./WineRangeAccessibility.vue?vue&type=script&lang=js"
export * from "./WineRangeAccessibility.vue?vue&type=script&lang=js"
import style0 from "./WineRangeAccessibility.vue?vue&type=style&index=0&id=35467876&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35467876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35467876')) {
      api.createRecord('35467876', component.options)
    } else {
      api.reload('35467876', component.options)
    }
    module.hot.accept("./WineRangeAccessibility.vue?vue&type=template&id=35467876&scoped=true", function () {
      api.rerender('35467876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineRangeAccessibility.vue"
export default component.exports